export const RPN_THRESHOLD = 150;
export const CRITICAL_SEVERITY = 9;
export const rpn = (it) => (Number(it.severity) || 0) * (Number(it.occurrence) || 0) * (Number(it.detection) || 0);
export const isCritical = (it) => (Number(it.severity) || 0) >= CRITICAL_SEVERITY;

export default function FmeaBlueprint({ doc }) {
  const items = [...(doc.payload?.items || [])].filter((i) => i.step || i.mode);
  // Critical-severity exposure ranks above pure RPN focus (HRO safety principle).
  items.sort((a, b) => (isCritical(b) - isCritical(a)) || (rpn(b) - rpn(a)));
  return (
    <div data-testid="fmea-blueprint">
      <div className="bg-white border border-slate-200 rounded-sm overflow-hidden">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
              <th className="px-4 py-2.5 font-semibold">Process Step / Failure Mode</th>
              <th className="px-3 py-2.5 font-semibold text-center">S</th>
              <th className="px-3 py-2.5 font-semibold text-center">O</th>
              <th className="px-3 py-2.5 font-semibold text-center">D</th>
              <th className="px-3 py-2.5 font-semibold text-center">RPN</th>
              <th className="px-3 py-2.5 font-semibold">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {items.length === 0 && <tr><td colSpan={6} className="px-4 py-6 text-center text-slate-300">No failure modes recorded.</td></tr>}
            {items.map((it) => {
              const r = rpn(it);
              const critical = isCritical(it);
              const flag = r > RPN_THRESHOLD;
              return (
                <tr key={it.id} data-testid={`fmea-row-${it.id}`} className={`${critical ? "bg-red-50 border-l-4 border-l-red-600" : flag ? "bg-red-50" : ""}`}>
                  <td className="px-4 py-3 text-slate-800">{it.step ? <span className="font-medium">{it.step}</span> : null}{it.step && it.mode ? " — " : ""}{it.mode}</td>
                  <td className={`px-3 py-3 text-center font-mono font-bold ${critical ? "text-red-700" : ""}`}>{it.severity || "—"}</td>
                  <td className="px-3 py-3 text-center font-mono">{it.occurrence || "—"}</td>
                  <td className="px-3 py-3 text-center font-mono">{it.detection || "—"}</td>
                  <td className={`px-3 py-3 text-center font-mono font-bold ${critical || flag ? "text-red-700" : "text-slate-700"}`} data-testid={`fmea-rpn-${it.id}`}>{r}</td>
                  <td className="px-3 py-3">
                    {critical ? (
                      <span data-testid={`fmea-critical-chip-${it.id}`} className="px-2 py-0.5 rounded-sm text-[10px] font-bold uppercase bg-red-600 text-white">Critical exposure</span>
                    ) : flag ? (
                      <span className="px-2 py-0.5 rounded-sm text-[10px] font-bold uppercase bg-red-600 text-white">Engineering control</span>
                    ) : (
                      <span className="text-xs text-slate-400">Monitor</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-xs text-slate-400 font-mono">RPN = S × O × D · items above {RPN_THRESHOLD} require engineering controls · Severity ≥ {CRITICAL_SEVERITY} is a Critical Exposure regardless of RPN.</p>
    </div>
  );
}
